__turbopack_context__.v({
  "exhibitionCard": "Tm8WZW_exhibitionCard",
  "figure": "Tm8WZW_figure",
  "image": "Tm8WZW_image",
  "meta": "Tm8WZW_meta",
  "status": "Tm8WZW_status",
  "title": "Tm8WZW_title",
});
